import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ac6fad02&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6fad02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac6fad02')) {
      api.createRecord('ac6fad02', component.options)
    } else {
      api.reload('ac6fad02', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ac6fad02&scoped=true&", function () {
      api.rerender('ac6fad02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vwO1T0MersFh/JS/comp/Accordion.vue"
export default component.exports